<template>
  <el-pagination
    class="base-pagination"
    v-bind="$attrs"
    v-on="$listeners"
    layout="prev, pager, next, total"
    @size-change="currentChange"
    @current-change="currentChange"
    @next-click="currentChange"
    @prev-click="currentChange"
  />
</template>
<script>
export default {
  methods: {
    currentChange (e) {
      this.$emit('pagination', e)
    },
  },
}
</script>

<style lang="less">
.base-pagination {
  padding: 15px 15px;
  background: #fff;
  text-align: center;
  border-radius: 0 0 10px 10px;
  /deep/.el-pager {
    li.number {
      border: 1px solid #f0f2f5;
      color: #999;
      border-radius: 4px;
      line-height: 25px;
      margin-left: 8px;
      height: 28px;
      width: 30px;
      min-width: 30px;
      padding: 0;
    }
    li.active {
      background: #00b3c0 !important;
      border: 1px solid #00b3c0;
      color: #e1e1e1;
    }
  }
  /deep/ .el-pagination__total {
    float: right;
  }
}
</style>
